<template>
  <article class="tariff-features">
    <h3 class="tariff-features__title">
      {{ title }}
    </h3>

    <ul class="tariff-features__list">
      <li v-for="(feature, index) in features" :key="index" class="tariff-features__item">
        <v-icon size="16" color="#4caf50">
          mdi-check
        </v-icon>
        <span>{{ feature }}</span>
      </li>
    </ul>
  </article>
</template>

<script>
  export default {
    name: 'TariffFeaturesCard',
    props: {
      tariffName: {
        type: String,
        default: null,
      },
      features: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      title () {
        return this.tariffName
          ? `Что входит в тарифный план «${this.tariffName}»`
          : 'Что входит в тариф'
      },
    },
  }
</script>

<style lang="less" scoped>
.tariff-features {
  background-color: #fff;
  border: 1px solid #c4cdd9;
  border-radius: 5px;
  padding: 22px;

  .media-xs({
    padding: 18px 16px;
  });

  &__title {
    font-size: 16px;
    font-weight: 700;
    color: #323030;
  }

  // Колонки заполняются сверху вниз, порядок пунктов сохраняется как в списке
  &__list {
    margin-top: 14px;
    padding: 0;
    list-style: none;
    columns: 4;
    column-gap: 28px;

    .media-lg({
      columns: 2;
    });

    .media-sm({
      columns: 1;
    });
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 5px 0;
    break-inside: avoid;
    font-size: 13px;
    color: #323030;
  }
}
</style>
